import React from 'react'
import PageMeta from '../components/PageMeta'
import GalleryLightbox from '../components/GalleryLightbox'
import { PAGES_DATA, COMPANY_INFO } from '../data/pagesData'

export default function ReferencePage() {
  const page = PAGES_DATA.reference

  const getOptimizedImg = (url, width = 1000) => {
    if (!url) return ''
    if (url.includes('assets.auxodev.dk') && !url.includes('/cdn-cgi/image/')) {
      return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=80,format=auto/`)
    }
    return url
  }

  const heroImageSrc = page.heroImage || "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/tilfaeldigt-sted-750x1000.jpg"

  return (
    <div>
      <PageMeta title={page.title} description={page.metaDescription} />

      {/* Top Hero Section: Image Left, Text Right */}
      <section className="bg-white text-slate-900 py-12 lg:py-[100px] border-b border-slate-200">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            
            {/* Left: Image matching page content */}
            <div className="w-full h-[280px] sm:h-[360px] lg:h-[420px] rounded-2xl overflow-hidden shadow-md border border-slate-200 bg-slate-100">
              <img
                src={getOptimizedImg(heroImageSrc, 1000)}
                alt={page.mainHeading}
                className="w-full h-full object-cover object-center"
              />
            </div>

            {/* Right: Text content */}
            <div className="space-y-4">
              <span className="text-xs font-bold uppercase tracking-widest text-[#046BB4] block">
                {page.topTag || "Sakskær Auto"}
              </span>
              
              <h1 className="text-2xl sm:text-3xl lg:text-[42px] font-black uppercase tracking-tight text-slate-900 leading-tight">
                {page.mainHeading}
              </h1>

              <p className="text-slate-600 text-sm sm:text-base leading-relaxed pt-1 whitespace-pre-line">
                {page.heroSub}
              </p>

              <div className="pt-2">
                <a
                  href={`tel:${COMPANY_INFO.phoneRaw}`}
                  className="inline-flex items-center gap-2.5 bg-[#046BB4] hover:bg-[#035590] text-white font-semibold px-6 py-3 rounded-lg transition-colors text-sm uppercase tracking-wide cursor-pointer shadow-md"
                >
                  <i className="fa-solid fa-phone" aria-hidden="true" />
                  <span>Ring: {COMPANY_INFO.phone}</span>
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto space-y-10">
            <div className="space-y-4">
              <h2 className="text-xl md:text-[28px] font-bold text-slate-900 uppercase tracking-wide">{page.mainHeading}</h2>
              <p className="text-slate-700 leading-relaxed text-base sm:text-lg">
                {page.text1}
              </p>
            </div>

            <div className="space-y-3">
              <h3 className="text-xl font-bold text-slate-900">{page.title2}</h3>
              <p className="text-slate-700 leading-relaxed">
                {page.text2}
              </p>
            </div>

            {/* Reference Gallery */}
            <GalleryLightbox
              gallerySlug="reference-galleri"
              fallbackImages={page.galleryImages}
              title="Projekter og referencer"
            />

            <div className="pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-sm text-slate-600">
                Ønsker du at drøfte dit næste projekt eller få et tilbud på din bil?
              </p>
              <a
                href={`tel:${COMPANY_INFO.phoneRaw}`}
                className="inline-flex items-center gap-2 bg-[#046BB4] hover:bg-[#035590] text-white font-semibold px-6 py-3 rounded-lg transition-colors shadow-xs text-sm uppercase tracking-wide cursor-pointer whitespace-nowrap"
              >
                <i className="fa-solid fa-phone" aria-hidden="true" />
                <span>Ring til os på {COMPANY_INFO.phone}</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
